export default __webpack_public_path__ + "static/media/whatsapp.a70fb4ca.svg";